<template>
<section class="vpn-section daily">
  <div class="vpn-section__inner">
    <h2 class="vpn-section__title">{{ dailyTitle }}</h2>
    <div class="daily__grid">
      <article v-for="item in sceneList" :key="item.title" class="daily__card">
        <div class="daily__head">
          <div class="daily__icon" v-html="item.icon" aria-hidden="true"></div>
          <div class="daily__card-title">{{ item.title }}</div>
        </div>
        <ul>
          <li v-for="tag in item.tags" :key="tag">{{ tag }}</li>
        </ul>
      </article>
    </div>
  </div>
</section>
</template>

<script>
import homeLocaleContent from '@/mixins/homeLocaleContent';

export default {
  name: 'DailyUseSection',
  mixins: [homeLocaleContent],
  computed: {
    dailyTitle() {
      return this.homeLocale?.dailyTitle || 'How Secure VPN Fits Into Your Daily Online Life';
    },
    sceneList() {
      if (!this.homeLocale?.dailyScenes?.length) {
        return this.defaultScenes;
      }
      return this.homeLocale.dailyScenes.map((scene, index) => ({
        ...this.defaultScenes[index],
        ...scene,
      }));
    },
  },
  data() {
    return {
      defaultScenes: [
        {
          title: 'Smooth & Stable Online Gaming',
          tags: ['Mobile Games', 'Multiplayer Online Games', 'Low Latency Connection', 'Protection Against DDoS'],
          icon: '<svg viewBox="0 0 24 24" width="28" height="28"><path fill="currentColor" d="M8.5 7h7A4.5 4.5 0 0 1 20 11.5v1A4.5 4.5 0 0 1 15.5 17h-7A4.5 4.5 0 0 1 4 12.5v-1A4.5 4.5 0 0 1 8.5 7zM8 11v1.5H6.5V14H5v-1.5H3.5V11H5V9.5h1.5V11H8zm7.2.2a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm2.3 2.3a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/></svg>',
        },
        {
          title: 'Private Video Calls & Secure Messaging',
          tags: ['Communication Apps', 'Voice & Video Calls', 'End-to-End Encrypted Browsing', 'Daily Social Connections'],
          icon: '<svg viewBox="0 0 24 24" width="28" height="28"><path fill="currentColor" d="M4 5.5A2.5 2.5 0 0 1 6.5 3h7A2.5 2.5 0 0 1 16 5.5V9l4-2.5v11L16 15v3.5A2.5 2.5 0 0 1 13.5 21h-7A2.5 2.5 0 0 1 4 18.5v-13z"/></svg>',
        },
        {
          title: 'Stay Connected Securely Anywhere',
          tags: ['Public Wi-Fi Networks', 'Workplaces & Offices', 'Educational Campuses', 'Airports & Hotels'],
          icon: '<svg viewBox="0 0 24 24" width="28" height="28"><path fill="currentColor" d="M12 18.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM6.2 12.8l1.5 1.5A6 6 0 0 1 12 13a6 6 0 0 1 4.3 1.3l1.5-1.5A8.1 8.1 0 0 0 12 11a8.1 8.1 0 0 0-5.8 1.8zm-3-3l1.5 1.5A10.3 10.3 0 0 1 12 8c2.9 0 5.6 1.1 7.3 3.3l1.5-1.5A12.4 12.4 0 0 0 12 6a12.4 12.4 0 0 0-8.8 3.8z"/></svg>',
        },
        {
          title: 'Protect Your Online Privacy',
          tags: ['Strong Data Encryption', 'Enhance IP Privacy', 'Strict No-Log Policy', 'ISP Data Protection'],
          icon: '<svg viewBox="0 0 24 24" width="28" height="28"><path fill="currentColor" d="M12 2.8 19 6v5.2c0 4.7-3 8.8-7 10.4-4-1.6-7-5.7-7-10.4V6l7-3.2zm0 10.7 3.5-3.5 1.4 1.4L12 16.3l-4.2-4.2 1.4-1.4L12 13.5z"/></svg>',
        },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/css/vpn-sections.scss';

.daily__grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 18px;
  width: 100%;
  margin: 0 auto;
  justify-content: center;
}

.daily__card {
  background: #fff;
  border: 1px solid var(--vpn-line, #e8e4f8);
  border-radius: 18px;
  padding: 22px 18px;
  box-shadow: 0 8px 24px rgba(31, 36, 48, 0.04);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  ul {
    list-style: none;
    width: min(100%, 188px);
    margin: 0 auto;
    padding: 0;
    text-align: left;
  }

  li {
    position: relative;
    padding-left: 14px;
    margin-bottom: 8px;
    color: var(--vpn-ink-muted, #5b6475);
    font-size: 14px;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 0.55em;
      width: 5px;
      height: 5px;
      border-radius: 50%;
      background: var(--vpn-brand, #6d4aff);
    }
  }
}

.daily__head {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;
  margin-bottom: 14px;

}

.daily__card-title {
  margin: 0;
  max-width: 170px;
  font-size: 16px;
  line-height: 1.35;
  color: var(--vpn-ink, #1f2430);
  font-weight: 700;
  text-align: left;
}

.daily__icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: rgba(109, 74, 255, 0.1);
  color: var(--vpn-brand, #6d4aff);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

@media (max-width: 1024px) {
  .daily__grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 560px) {
  .daily__grid {
    grid-template-columns: 1fr;
  }

  .daily__card {
    padding: 18px 14px;
  }

  .daily__head {
    max-width: 100%;
    justify-content: flex-start;
  }

  .daily__card-title {
    max-width: none;
  }

  .daily__card ul {
    width: 100%;
  }
}
</style>
